export default "__VITE_ASSET__BlY8RdKy__"